import {
  clearSuperAdminLogin,
  saveSuperAdminLogin,
} from "./superadmin-storage";

const superAdminReducer = (state, action) => {
  switch (action.type) {
    case "SUPER_ADMIN_LOGIN":
      saveSuperAdminLogin(action.payload.token, action.payload.user);
      return {
        ...state,
        token: action.payload.token,
        user: action.payload.user,
      };

    case "SUPER_ADMIN_LOGOUT":
      clearSuperAdminLogin();
      return {
        ...state,
        token: null,
        user: null,
      };

    default:
      return state;
  }
};

export default superAdminReducer;
